import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {AnswerService} from '../../../services/api/answer.service';
import {AnswerOption} from '../../../data/models/test/answer';

@Component({
  selector: 'app-answer-option-delete-dialog',
  templateUrl: './answer-option-delete-dialog.component.html',
  styleUrls: ['./answer-option-delete-dialog.component.css']
})
export class AnswerOptionDeleteDialogComponent implements OnInit {

  testId: number;
  questionId: number;
  option: AnswerOption;

  constructor(
    private answerService: AnswerService,
    public dialogRef: MatDialogRef<AnswerOptionDeleteDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: {
      testId: number,
      questionId: number,
      option: AnswerOption,
    },
  ) {
    this.testId = data.testId;
    this.questionId = data.questionId;
    this.option = data.option;
  }

  ngOnInit(): void {
  }

  onSubmit(): void {
    this.answerService.deleteAnswerOption(this.testId, this.questionId, this.option.id)
      .then(() => this.dialogRef.close(true));
  }

  onCancel(): void {
    this.dialogRef.close();
  }

}
